import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var ticketsSpotIcon = /*#__PURE__*/React.createElement("svg", {
  height: "48",
  width: "48",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.411 0c1.112 0 2.17.622 2.688 1.665l.085.188 1.187 2.865a4.998 4.998 0 0 0 2.8 9.143c.21 0 .421-.013.633-.04l.317-.05 1.186 2.864a3 3 0 0 1-1.462 3.848l-.16.072L30.535 26H41a3 3 0 0 1 2.995 2.824L44 29v3.101a5 5 0 0 0-.212 9.75L44 41.9V45a3 3 0 0 1-2.824 2.995L41 48H7a3 3 0 0 1-2.995-2.824L4 45V29a3 3 0 0 1 1.966-2.817L2.229 17.16a3 3 0 0 1 1.462-3.848l.161-.072L35.265.229A2.978 2.978 0 0 1 36.411 0zM32 28H7a1 1 0 0 0-.993.883L6 29v16a1 1 0 0 0 .884.993L7 46h25v-3h2v3h7a1 1 0 0 0 .993-.883L42 45v-1.676A7.026 7.026 0 0 1 38 37a7.026 7.026 0 0 1 3.764-6.206l.236-.118V29a1 1 0 0 0-.884-.993L41 28h-7v3h-2v-3zm2 6v6h-2v-6h2zm2.411-32a.975.975 0 0 0-.256.034l-.125.043-6.467 2.678 1.108 2.677-1.848.765-1.109-2.677-23.096 9.568a1.001 1.001 0 0 0-.58 1.197l.04.11L8.054 26H25.31l9.294-3.85-1.116-2.693 1.847-.765 1.116 2.693 6.467-2.678c.474-.196.716-.716.58-1.197l-.039-.11-.64-1.547a6.98 6.98 0 0 1-6.117-4.313 7.032 7.032 0 0 1 1.096-7.167l.18-.207-.642-1.548A.996.996 0 0 0 36.411 2zm-4.574 8.246 2.332 5.63-1.848.766-2.332-5.63 1.848-.766z",
  fill: "#0A0B09"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.85 14.341 2.284.136a.692.692 0 0 1 .445 1.158l-1.682 1.626.687 2.087a.69.69 0 0 1-.963.78l-1.96-.911-1.879 1.113a.69.69 0 0 1-1.04-.675l.49-2.149-1.868-1.439a.691.691 0 0 1 .32-1.198l2.282-.377.705-2.043a.691.691 0 0 1 1.238-.065l.941 1.957z",
  fill: "#AB3136"
})));

export { ticketsSpotIcon as default };
//# sourceMappingURL=ticketsSpotIcon.js.map
